<template>
	<div class="box-content">
    <template v-if="polls.rows.length > 0">
      <template v-for="poll in polls.rows">
        <div :class="[ poll.hasImage == 'Y' ? 'box-poll-pic' : 'box-poll' ]">
					<div class="topic">
						{{ poll.topic }}
					</div>
					<template v-for="choice in poll.choices">
						<choice	:choice="choice"
								:poll="poll"
								:progressPercent="progressPercent"
								:hasImage="poll.hasImage == 'Y'"
								:postSelectChoice="postSelectChoice"
                :filePath="filePath" />
					</template>

					<add-choice v-if="poll.addChoice === 'Y' && poll.choices.length < poll.maxChoices"
								:collapsed="collapsed"
								:poll="poll"
								:hasImage="poll.hasImage == 'Y'"
								:nowLang="nowLang"
								:postChoice="postChoice"
                :filePath="filePath" />

					<div class="date-box">
						<i class="fa fa-thumbs-o-up like" aria-hidden="true"></i>
						<div class="total-vote">{{ poll.totalVote }}</div>
						<div class="date-poll">{{ poll.dtestrt }} - {{ poll.dteend }}</div>
						<i class="fa fa-clock-o clock" aria-hidden="true"></i>
					</div>
				</div>
      </template>
		</template>
    <template v-else>
      <poll-none />
      <div class="view-history cursor-pointer" @click="toggleOldPoll()" v-show="!triggerOldPollInfiniteBool">
        <i class="fa fa-history" aria-hidden="true"></i>
        <p>{{ pollHistory }}</p>
        <div class="clearfix"></div>
      </div>
    </template>
    <hrms-infinite-loading v-if="triggerPollInfiniteBool" @infinite="onInfinite" ref="pollsLoading" >
      <div slot="no-more" class="view-history cursor-pointer" @click="toggleOldPoll()" v-show="!triggerOldPollInfiniteBool">
        <i class="fa fa-history" aria-hidden="true"></i>
        <p>{{ pollHistory }}</p>
        <div class="clearfix"></div>
      </div>
    </hrms-infinite-loading>
		<old-poll 	v-show="triggerOldPollInfiniteBool"
					:oldPolls="oldPolls"
					:progressPercent="progressPercent"
					:receivedOldPollsInfiniteLoading="receivedOldPollsInfiniteLoading"
					:triggerOldPollInfiniteBool="triggerOldPollInfiniteBool"
					:triggerOldPollResetBool="triggerOldPollResetBool"
          :filePath="filePath"
					@disableTriggerOldPollResetBool="triggerOldPollResetBool = false" />
	</div>
</template>

<script>
import addChoice from 'components/poll/addChoice'
import oldPoll from 'components/poll/oldPoll'
import choice from 'components/poll/choice'
import pollNone from 'components/poll/none'
import * as types from 'store/modules/poll/mutation-types'

export default {
  name: 'poll-index',
  props: [ 'polls', 'pollAddChoice', 'pollHistory', 'collapsed', 'progressPercent', 'nowLang', 'triggerPollInfiniteBool', 'receivedPollsInfiniteLoading', 'oldPolls', 'receivedOldPollsInfiniteLoading', 'postChoice', 'postSelectChoice', 'triggerResetBool', 'filePath' ],
  components: {
    addChoice,
    oldPoll,
    choice,
    pollNone
  },
  data () {
    return {
      page: 1,
      limit: 10,
      triggerOldPollInfiniteBool: false,
      triggerOldPollResetBool: false
    }
  },
  created () {
    this.$store.commit(types.RESET_POLLS)
  },
  watch: {
    triggerResetBool () {
      if (this.triggerResetBool) {
        this.triggerOldPollResetBool = true
        this.page = 1
        this.limit = 10
        this.$store.commit(types.RESET_POLLS)
        this.$nextTick(function () {
          this.$refs.pollsLoading.$emit('$InfiniteLoading:reset')
        })
        this.$emit('disableTriggerResetBool')
      }
    }
  },
  methods: {
    toggleOldPoll () {
      this.triggerOldPollInfiniteBool = true
    },
    onInfinite ($state) {
      this.receivedPollsInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        searchParams: {
          p_page: this.page,
          p_limit: this.limit
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ length, $state }) {
      if (length > 0) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?65cdc77b